import { GraduationCap } from "lucide-react";
import { useTranslation } from "react-i18next";

const FeedbackSection = ({ report }) => {
    const { t } = useTranslation();
  const feedback = report?.overall_feedback || "";

  return (
    <div className="space-y-6">
      {/* Overall Teacher Feedback */}
      <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200">
        <h3 className="text-lg font-bold mb-4 flex items-center space-x-2">
          <GraduationCap className="w-5 h-5 text-blue-600" />
          <span>{t("feedback.overallFeedback")}</span>
        </h3>

        {feedback ? (
          <p className="text-slate-700 leading-relaxed">{feedback}</p>
        ) : (
          <p className="text-slate-400 italic">{t("feedback.noFeedbackAvailable")}</p>
        )}
      </div>
    </div>
  );
};

export default FeedbackSection;
